import { get } from 'lodash';
import React from 'react';
import { ANTRAGS_FORMULAREN, PLATZHALTER_TEXT, VORHABENS_ART } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import AssoziiertePartnerSkizzeGlobal, { getFormStrucAssoziiertePartnerSkizzeGlobal } from './content/AssoziiertePatnerSkizzeGlobal';
import VerbundpartnerSkizzeGlobal, { getFormStrucVerbundpartnerSkizzeGlobal } from './content/VerbundpartnerSkizzeGlobal';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { checkIfAnyPartnerHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
const P = AntragSchema.attributes;

export const TreeStructureSkizzeVerbundpartnerGlobal = (application: any, readOnly: boolean) => {
	let treeNodes: TreeNodeType[] = [];

	const hasAnyPartnerComment = checkIfAnyPartnerHasComment(readOnly, application);
	const hasAnyAssoPartnerHasComment = checkIfAnyPartnerHasComment(readOnly, application, true);

	if (get(application, P.Allgemein_Vorhabensart.path, '') === VORHABENS_ART.Verbundvorhaben) {
		treeNodes = [
			{
				label: 'Projektpartner',
				content: <ApplicationHeading title='Projektpartner' description={PLATZHALTER_TEXT} />,
				hasComment: hasAnyPartnerComment || hasAnyAssoPartnerHasComment,
				children: [
					{
						label: 'Verbundpartner',
						content: <VerbundpartnerSkizzeGlobal hasAnyPartnerComment={hasAnyPartnerComment} />,
						formStruc: getFormStrucVerbundpartnerSkizzeGlobal(application, readOnly),
						hasComment: hasAnyPartnerComment,
					},
					...SkizzeAssoziiertePartner(application, hasAnyAssoPartnerHasComment),
				],
			},
		];
	}
	return treeNodes;
};

const SkizzeAssoziiertePartner = (application: any, hasAnyAssoPartnerHasComment?: boolean) => {
	let treeNodes: TreeNodeType[] = [];

	const antragsFormular = get(application, P.Allgemein_Antragsformular.path, {});

	if (antragsFormular === ANTRAGS_FORMULAREN.Loewe) {
		treeNodes = [
			{
				label: 'Assoziierte Partner',
				content: <AssoziiertePartnerSkizzeGlobal hasAnyPartnerComment={hasAnyAssoPartnerHasComment} />,
				formStruc: getFormStrucAssoziiertePartnerSkizzeGlobal(application),
				hasComment: hasAnyAssoPartnerHasComment,
			},
		];
	}

	return treeNodes;
};
